import { httpClient, ApiResponse, convertModelToFormData } from '@/utils';
import {
  getInterLinkEndpoints,
  ICreateInterLinkDTO,
  ICreateInterLinkResponse,
  IDeleteInterLinkDTO,
  IDeleteInterLinkResponse,
  IExportInterLinks,
  IGetInterLinksDTO,
  IGetInterLinksResponse,
  IInterLinkImportDTO,
  IInterLinksImportResponse,
  IUpdateInterLinkDTO,
  IUpdateInterLinkResponse,
  staticInterLinkEndpoints,
} from '@/models/linkingTool.model';

class LinkingToolAPI {
  static getLinkingTools(params: IGetInterLinksDTO): ApiResponse<IGetInterLinksResponse> {
    const { GET_INTER_LINK_LIST } = staticInterLinkEndpoints;
    return httpClient.get<IGetInterLinksResponse>(GET_INTER_LINK_LIST, {
      params,
    });
  }

  static exportInterLinks(params: IExportInterLinks): ApiResponse<Blob> {
    const { EXPORT_IMPORT_LINKS } = staticInterLinkEndpoints;
    return httpClient.get<Blob>(EXPORT_IMPORT_LINKS, {
      params,
    });
  }

  static createInterLink(data: ICreateInterLinkDTO): ApiResponse<ICreateInterLinkResponse> {
    const { CREATE_INTER_LINK } = staticInterLinkEndpoints;
    return httpClient.post<ICreateInterLinkResponse>(CREATE_INTER_LINK, data, {
      params: { channelId: data?.channelId },
    });
  }

  static updateInterLink({ id, ...data }: IUpdateInterLinkDTO): ApiResponse<IUpdateInterLinkResponse> {
    const { UPDATE_INTER_LINK } = getInterLinkEndpoints({ id });
    return httpClient.put<IUpdateInterLinkResponse>(UPDATE_INTER_LINK, data);
  }

  static deleteInterLink({ id }: IDeleteInterLinkDTO): ApiResponse<IDeleteInterLinkResponse> {
    const { DELETE_INTER_LINK } = getInterLinkEndpoints({ id });
    return httpClient.delete<IDeleteInterLinkResponse>(DELETE_INTER_LINK);
  }

  static importInterLink(data: IInterLinkImportDTO): ApiResponse<IInterLinksImportResponse> {
    const { IMPORT_LINKS } = staticInterLinkEndpoints;
    const formData = convertModelToFormData(data, new FormData(), '', true);
    return httpClient.post<IInterLinksImportResponse>(IMPORT_LINKS, formData, {
      params: { channelId: data?.channelId },
    });
  }
}

export default LinkingToolAPI;
